import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.page.html',
  styleUrls: ['./highlights.page.scss'],
})
export class HighlightsPage {
  //declared variables
  public assets = environment.assets;
  //constructor
  constructor() { }
}
